export const build = {"tag":"v1.0.5","hash":"ff2455ff","time":"261013.1105"}